"use strict";
// Asset types for front and back end
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetStatus = void 0;
var AssetStatus;
(function (AssetStatus) {
    AssetStatus["DRAFT"] = "DRAFT";
    AssetStatus["REGISTERED"] = "REGISTERED";
    AssetStatus["DISPOSED"] = "DISPOSED";
})(AssetStatus || (exports.AssetStatus = AssetStatus = {}));
